// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleOnlyThisPeriod_root__SkLUN","text":"ToggleOnlyThisPeriod_text__1qc3u","active":"ToggleOnlyThisPeriod_active__1mx5N"};